import { FormControl, FormLabel, Stack, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import PageTitle from "../../common/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { setSearchKey } from "../../state/jobSeeker/jobSeekerSlice";
import { selectJobSeekerState } from "../../state/jobSeeker/jobSeekerSelector";
import debounceHandler from "../../helpers/utils/debounceHandler";
const JobSeekerHeader = () => {
  const dispatch = useDispatch();
  const { searchKey } = useSelector(selectJobSeekerState);

  const handleSearch = debounceHandler((e) => {
    dispatch(setSearchKey(e.target.value));
  }, 1000);
  return (
    <>
      <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} justifyContent={"space-between"} spacing={2} mb={3}>
        <PageTitle title={"Job Seeker"} mb={0} subTitleMb={0} />
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "flex-end" }} sx={{ width: { xs: "100%", md: "auto" } }}>
          <FormControl sx={{ flexGrow: 1, minWidth: { xs: "100%", sm: 200 }, maxWidth: { md: 330 } }}>
            <FormLabel>Search By Job Seeker Name or Email:</FormLabel>
            <TextField
              size={"small"}
              type={"search"}
              placeholder={"Search..."}
              InputProps={{
                startAdornment: <SearchRoundedIcon fontSize={"small"} color={"action"} sx={{ ml: 1 }} />,
              }}
              defaultValue={searchKey}
              onChange={handleSearch}
            />
          </FormControl>
        </Stack>
      </Stack>
    </>
  );
};

export default JobSeekerHeader;
